import React from "react";
import Error from "../../../components/Error";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { useAuth } from "../hooks/useAuth";
import Loading from "../../../components/Loading";
import Typography from "@material-ui/core/Typography";
import { AdapterLink } from "../../../components/Adopter";

const useStyles = makeStyles(() => ({
  icon: {
    borderRadius: "50%",
    border: "2px solid",
    borderColor: "inherit",
    paddingTop: 15,
    height: 70,
    width: 70,
  },
  textContainer: {
    display: "block",
    width: "100%",
    marginTop: 50,
    marginBottom: 20,
  },
}));
export default function VerifySchool() {
  const classes = useStyles();

  const {
    data: { verifying },
  } = useAuth();

  return (
    <>
      {verifying && <Loading />}
      <Error icon={"plane"} iconProps={{ className: classes.icon }}>
        You don't have assigned school, please contact to admin
        <Typography variant={"caption"} className={classes.textContainer}>
          If you need more info please{" "}
          <AdapterLink href="mailto:support@worlded.us">
            contact support
          </AdapterLink>
          .
        </Typography>
      </Error>
    </>
  );
}
